export const maskPhoneNumber = (phone: string) => {
    const digits = phone.replace(/\D/g, "");
    const national = digits.startsWith("48") && digits.length > 9 ? digits.slice(-9) : digits;

    if (national.length < 6) return phone;

    return `+48 ${national.slice(0, 3)} *** ${national.slice(-3)}`;
};
export const maskPhoneNumber = (phone: string) => {
    const digits = phone.replace(/\D/g, "");
    const national = digits.startsWith("48") && digits.length > 9 ? digits.slice(-9) : digits;

    if (national.length < 6) return phone;

    return `+48 ${national.slice(0, 3)} *** ${national.slice(-3)}`;
};
